import { render, staticRenderFns } from "./eb-skeleton-button.vue?vue&type=template&id=38a2e9ae&"
import script from "./eb-skeleton-button.vue?vue&type=script&lang=js&"
export * from "./eb-skeleton-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports